import { WiTime1 } from "react-icons/wi";
import { FaInbox, FaRegCheckCircle } from "react-icons/fa";
import { MdErrorOutline } from "react-icons/md";
import { GiSandsOfTime } from "react-icons/gi";
import { Navigate } from "react-router-dom";
import CustomNavigate from "../components/custom-navigate";
import AcceptRules from "../components/accept-rules";
import ResponseCm from "../components/errors-cm";
import RemainigTime from "../components/remainig-time";
import ExamQuestions from "../components/exam-questions";

export const SOCKET_OBJ_TOAST = {
  warn: {
    color: "#f1c40f",
  },
  error: {
    color: "#e74c3c",
  },
  info: {
    color: "#3498db",
  },
  success: {
    color: "#07bc0c",
  },
};

export const SOCKET_OBJ_DATA = {
  2000: {
    icon: <FaRegCheckCircle fontSize={58} />,
    content: ({ socket, data }) => (
      <ExamQuestions data={data} socket={socket} />
    ),
  },
  481493: {
    icon: <FaRegCheckCircle fontSize={58} />,
    content: ({ socket, data }) => <AcceptRules data={data} socket={socket} />,
  },
  471493: {
    icon: <FaRegCheckCircle fontSize={58} />,
    content: () => {},
  },
  43992: {
    icon: <MdErrorOutline fontSize={58} />,
    content: () => <CustomNavigate to={"/login-otp/"} />,
  },
  443326: {
    icon: (
      <GiSandsOfTime
        className=" animate-[pulse_1s_ease-in-out_infinite]"
        fontSize={58}
      />
    ),
    content: ({ data }) => (
      <ResponseCm data={data}>
        <div>
          <RemainigTime time={data.time.totalSecond} />
        </div>
      </ResponseCm>
    ),
  },
  914794: {
    icon: (
      <GiSandsOfTime
        className=" animate-[pulse_1s_ease-in-out_infinite]"
        fontSize={58}
      />
    ),
    content: ({ data }) => (
      <ResponseCm data={data}>
        <div>
          <RemainigTime time={data.time.totalSecond} />
        </div>
      </ResponseCm>
    ),
  },
  932459: {
    icon: <WiTime1 fontSize={58} />,
    content: ({ data }) => <ResponseCm data={data} />,
  },
  103832: {
    icon: <WiTime1 fontSize={58} />,
    content: ({ data }) => <ResponseCm data={data} />,
  },
  827416: {
    icon: <FaInbox fontSize={58} />,
    content: ({ data }) => <ResponseCm data={data} />,
  },
  346279: {
    icon: <MdErrorOutline fontSize={58} />,
    content: ({ data }) => (
      <ResponseCm data={data}>
        <button
          color="error"
          sx={{ mt: 3 }}
          className="text-lg mt-5 p-2 px-3 duration-300 shadow-xl hover:bg-primary-700 bg-primary-600 text-white rounded-md !font-extralight !font-dana-normal"
          onClick={() => window.location.reload()}
        >
          تلاش مجدد
        </button>
      </ResponseCm>
    ),
  },
  463326: {
    icon: <WiTime1 fontSize={58} />,
    content: ({ data }) => (
      <ResponseCm data={data}>
        <div className="flex flex-row gap-2">
          <a
            href="https://account.dana-institute.ir/userPanel"
            target="_blank"
            rel="noreferrer"
            className="text-lg mt-5 p-2 px-3 duration-300 shadow-xl hover:bg-primary-700 bg-primary-600 text-white rounded-md !font-extralight !font-dana-normal"
          >
            حساب کاربری
          </a>
        </div>
      </ResponseCm>
    ),
  },
  666666: {
    icon: <FaRegCheckCircle fontSize={58} />,
    content: ({ socket, data }) => (
      <ResponseCm data={data} socket={socket}>
        <div className="flex flex-row gap-2">
          <a
            href="https://account.dana-institute.ir/userPanel"
            target="_blank"
            rel="noreferrer"
            className="text-lg mt-5 p-2 px-3 duration-300 shadow-xl hover:bg-primary-700 bg-primary-600 text-white rounded-md !font-extralight !font-dana-normal"
          >
            حساب کاربری
          </a>
        </div>
      </ResponseCm>
    ),
  },

  // 463326: {
  //   icon: <MdErrorOutline fontSize={58} />,
  //   content: (
  //     <CustomNavigate
  //       to={"https://account.dana-institute.ir/"}
  //       withParams={false}
  //     />
  //   ),
  // },
};
